// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"102":"4ee0ef7f","133":"766e5a5b","182":"9b0370b2","213":"2899fc6c","748":"958a24d1","917":"27007340"}[chunkId] + ".chunk.js";
};